export interface IMapStore {
  verificationStatus: EVerificationStatuses | string;
  certificationStatus: ECertificationStatuses | string;
  isVerified: boolean;
  isCertified: boolean;
  isCertifiedOrSelfCertified: boolean;
  tier: ETiers | string;
}

export enum EVerificationStatuses {
  verified,
  pending,
  expired,
  unverified,

  // TODO: Remove after core verification/certification statuses are deprecated
  awaiting_verification,
  rejected,
  incomplete,
  fully_verified,
  part_verified,
}

export enum ECertificationStatuses {
  certified,
  self_certified,
  pending,
  expired,
  uncertified,

  // TODO: Remove after core verification/certification statuses are deprecated
  waiting,
  awaiting_certification,
  rejected_certification,
  waited_30_days,
}

export enum ETiers {
  tier_0,
  tier_0_kyc,
  tier_1_uk_restricted,
  tier_1,
  tier_2,
  tier_3,
  tier_3_4, // tier === null
  tier_4,
}

export interface IGetLableConfig {
  [key: string]: {
    value: string | ((type: string) => string);
    color: string;
    redirect?: {
      url: string | ((type: string) => string);
      label: string;
    };
  };
}
